export default __webpack_public_path__ + "static/media/ranking-bg.ee8a2453.png";